// Forked from api/msw/api/selectLists/caseTypes/mockData.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
// ⚠ ONE seed, imported -- this module used to declare its own
// `getStartingServiceRequestTypeListData` with the SAME ids bound to the OPPOSITE labels
// (XXSRT0001 as 'Address Change'). Nothing reconciled them, so which pairing a
// browser saw depended on how the store was filled: a cold start took this
// module's copy, while "Start Over" reseeds from api/msw/modules/mockData.ts,
// which has always used the entity one. The four seeded cases all embed
// one of its types, so the entity file is the authority.
import { getStartingServiceRequestTypeListData } from '../../serviceRequestTypes/mockData'
import type { IServiceRequestType } from '~/types/serviceRequest/models'
import type { TEntityId, ISelectItem } from '~/types/models'

const serviceRequestTypeListData = undefined as unknown as IServiceRequestType[]

export const getServiceRequestTypeListData = getListDataFunctionFactory<
  IServiceRequestType[]
>({
  listData: serviceRequestTypeListData,
  storageKey: 'servicerequesttypes',
  getStartingListData: getStartingServiceRequestTypeListData,
})

export function _getCATDataById(
  id: TEntityId,
  list: IServiceRequestType[]
): IServiceRequestType {
  if (!list) {
    throw new Error(`_getCATDataById called with undefined/falsey list`)
  }
  const serviceRequestType = list.find(
    (lt: IServiceRequestType) => lt.id === id
  )
  if (!serviceRequestType) {
    throw new Error(`Can't find serviceRequestType '${id}'`)
  }
  return serviceRequestType
}

export function _getCATSelectItemDataByLabel(
  label: string,
  list: IServiceRequestType[]
): ISelectItem {
  if (!list) {
    throw new Error(`_getCATDataById called with undefined/falsey list`)
  }
  const serviceRequestType = list.find((lt) => lt.descr === label)
  if (!serviceRequestType) {
    throw new Error(`Can't find serviceRequestType '${label}'`)
  }
  return { id: serviceRequestType.id, label: serviceRequestType.descr }
}

export async function getServiceRequestTypeDataById(
  id: TEntityId
): Promise<IServiceRequestType> {
  const list: IServiceRequestType[] = await getServiceRequestTypeListData()
  return _getCATDataById(id, list)
}

export async function getServiceRequestTypeDataByLabel(
  label: string
): Promise<IServiceRequestType> {
  const list: IServiceRequestType[] = await getServiceRequestTypeListData()
  if (!list) {
    throw new Error(`getServiceRequestTypeListData returned undefined/null`)
  }
  const lt = list.find(
    (serviceRequestType) => serviceRequestType.label === label
  )
  if (!lt) {
    throw new Error(`Can't find serviceRequestType '${label}'`)
  }
  return lt
}

export async function getServiceRequestTypeSelectItemDataByLabel(
  label: string
): Promise<ISelectItem> {
  const list: IServiceRequestType[] = await getServiceRequestTypeListData()
  return _getCATSelectItemDataByLabel(label, list)
}
